import PropTypes from 'prop-types';
import classnames from 'classnames';
import { LoadBlock } from '@bwoty-web/styleguide';
import { SearchBarPanel } from '../SearchBarPanel/SearchBarPanel';
import { SearchPanelHeader } from '../SearchBarPanel/SearchPanelHeader';
import { SearchBarControls } from '../SearchBarPanel/SearchBarControls';
import { SortingBar } from '../SortingBar';
import SearchOption from '../SearchOption/SearchOption';
import SearchOptionButton from '../SearchOption/SearchOptionButton';

import styles from './SearchBarPlaceholder.scss';

// eslint-disable-next-line react/prop-types
const PlaceholderText = ({ w, h, darkBg }) => {
  const c = classnames({
    [styles.loadBlockDarkBg]: darkBg,
  });

  return <LoadBlock style={{ height: h, width: w }} className={c} />;
};

const PlaceholderField = () => {
  return (
    <SearchOption>
      <SearchOptionButton header={<PlaceholderText w={90} h={15} />}>
        <PlaceholderText w={70} h={19} />
      </SearchOptionButton>
    </SearchOption>
  );
};

export function SearchBarPlaceholder(props) {
  const { searchInitialOpen } = props;

  const placeHolderField = <PlaceholderField />;

  return (
    <>
      <SearchBarPanel>
        <SearchPanelHeader isHidden={searchInitialOpen} isLoading buttonLabel={'\u00A0'}>
          <PlaceholderText w={165} h={16} darkBg />
        </SearchPanelHeader>
        <SearchBarControls
          isOpen={searchInitialOpen}
          isLoading
          departureField={placeHolderField}
          dateFromField={placeHolderField}
          dateToField={placeHolderField}
          tripLengthField={placeHolderField}
          buttonLabel={'\u00A0'}
        />
      </SearchBarPanel>
      <SortingBar
        dateSortLabel={<PlaceholderText w={80} h={20} />}
        priceSortLabel={<PlaceholderText w={80} h={20} />}
        filterLabel={<PlaceholderText w={74} h={24} />}
      />
    </>
  );
}

SearchBarPlaceholder.propTypes = {
  searchInitialOpen: PropTypes.bool,
};
